import { useEffect, useState } from "react";

export function useCountdown(startSeconds: number) {
  const [remaining, setRemaining] = useState(startSeconds);

  useEffect(() => {
    const timer = setInterval(() => {
      setRemaining((prev) => (prev <= 0 ? startSeconds : prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [startSeconds]);

  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor((remaining % 3600) / 60);
  const seconds = remaining % 60;
  return { hours, minutes, seconds };
}
